import { render } from "./gameCategoryView.vue?vue&type=template&id=38312a0c&scoped=true"
import script from "./gameCategoryView.vue?vue&type=script&lang=js"
export * from "./gameCategoryView.vue?vue&type=script&lang=js"

import "./gameCategoryView.vue?vue&type=style&index=0&id=38312a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38312a0c"]])

export default __exports__